<template>
  <!--  置顶跳转页面 包含简易和招标-->
  <div class="project-info-div">
    <project v-if="projectType == 1" :project="listDetail" :projectId="$route.query.id" :oldInfo="0"/>
    <div v-else class="getJobSimpleDetail">
      <div class="basic">
        <div class="title">{{ listDetail.name }}</div>
        <div class="tagBox">
          <span class="is-auth-tag" v-show="listDetail.isAuth === 1 && listDetail.otherPub !== 1">已实名</span>
          <span v-show="listDetail.category == 0">个人</span>
          <span v-show="listDetail.category == 1">班组</span>
          <span v-show="listDetail.category == 2">企业</span>
          <span v-if="listDetail.workerNum !== 0">招{{ listDetail.workerNum }}人</span>
          <span v-else>人数不限</span>
          <span v-show="listDetail.isLatest == 1">最新发布</span>
          <span v-show="listDetail.isFull == 1">即将招满</span>
          <span v-show="listDetail.isLongTerm == 1">长期招聘</span>
        </div>
        <div class="textTitle" v-if="listDetail.workTypes">工种：{{ listDetail.workTypes }}</div>
        <div class="textTitle">发布时间： {{ listDetail.pubTimeStr }}</div>
        <div class="textTitle">有效期：{{ listDetail.signTime }}</div>
        <div class="textTitle">派活对象：{{ listDetail.objects }}</div>
      </div>
      <div class="headline">项目描述</div>
      <div class="basic clearfix">
        <div class="textTitle" ref="intro" :class="isMore? 'retract': 'open'">{{ listDetail.intro }}</div>
        <template v-if="haMore">
          <img src="../../assets/images/getJob/icon_zhankai.png" class="icon_zhankai" @click="isMore = !isMore"
               v-if="isMore">
          <img src="../../assets/images/getJob/icon_shouqi.png" class="icon_zhankai" @click="isMore = !isMore" v-else>
        </template>
      </div>
      <div class="headline">招工方</div>
      <div class="basic" v-if="listDetail.otherPub !== 1">
        <div class="hireParty">
          <div class="personLogo">
            <img src="../../assets/images/publicImg/touxiang_default.png" v-if="!listDetail.img">
            <img :src="listDetail.img" v-else>
          </div>
          <div class="rightContainer">
            <div class="textTitle" style="font-weight: bold;margin-bottom: 0;line-height: 22px">{{
                listDetail.pubName
              }}
            </div>
            <div class="WRAST clearfix">
              <div class="inlineStyle">
                <span class="textTitle" v-if="listDetail.creditStar.socreLevel == -1">黑名单</span>
                <span class="textTitle" v-if="listDetail.creditStar.socreLevel == 0">信用未评级</span>
                <img src="../../assets/images/getJob/icon_star_1.png" class="star_one"
                     v-if="listDetail.creditStar.starCount === 1">
                <img src="../../assets/images/getJob/icon_star_2.png" class="star_two"
                     v-if="listDetail.creditStar.starCount === 2">
                <img src="../../assets/images/getJob/icon_star_3.png" class="star_three"
                     v-if="listDetail.creditStar.starCount === 3">
                <img src="../../assets/images/getJob/icon_star_4.png" class="star_four"
                     v-if="listDetail.creditStar.starCount === 4">
                <img src="../../assets/images/getJob/icon_star_5.png" class="star_five"
                     v-if="listDetail.creditStar.starCount === 5">
              </div>
              <img src="../../assets/images/getJob/icon_more.png" class="icon_more" @click="hirePartyDetail">
            </div>
          </div>
        </div>
        <div class="phoneBox">
          <div>
            <img src="../../assets/images/getJob/btn_addFriend.png" class="btn_addFriend"
                 v-show="listDetail.isFriend == 0" @click="addFriends">
            <img src="../../assets/images/getJob/btn_addFriendDis.png" class="btn_addFriend"
                 v-show="listDetail.isFriend == 1">
          </div>
          <div>
            <img src="../../assets/images/getJob/btn_phone.png" class="btn_phone" @click="callPhone(listDetail.mobile)">
          </div>

        </div>
      </div>
      <div class="basic" v-else>
        <div class="otherPubBox">
          <div class="leftBox">
            <div class="personLogo">
              <img src="../../assets/images/publicImg/touxiang_default.png" v-if="!listDetail.img">
              <img :src="listDetail.img" v-else>
            </div>
            <div class="textTitle" style="font-weight: bold;height: 20px;margin-bottom: 0">{{
                listDetail.personName
              }}
            </div>
          </div>
          <img src="../../assets/images/getJob/btn_phoneDai.png" class="btn_phoneDai"
               @click="callPhone(listDetail.mobile)">
        </div>
      </div>

      <template v-if="listDetail.lng && listDetail.lat">
        <div class="headline">项目地址</div>
        <div class="basic">
          <template>
            <div class="icon_dizhiBox">
              <img src="../../assets/images/publicImg/icon_dizhi.png" class="icon_dizhi">
              <span class="textTitle">{{ listDetail.address }}</span>
            </div>
            <div class="mapbox">
              <div class="map" id="container"></div>
            </div>
            <div class="hint">提示：点击地图可导航</div>
          </template>
        </div>
      </template>

      <div class="headline" v-if="listDetail.attachs !== undefined && listDetail.attachs.length > 0">附件</div>
      <div class="basic" v-if="listDetail.attachs !== undefined && listDetail.attachs.length > 0">
        <div class="fileContainer" v-for="(item, index) in listDetail.attachs" :key="index"
             @click="attachsDetail(item.attachUrl)">
          <span v-if="item.fileType ==='pdf'" class="icon_pdf"></span>
          <span v-else-if="item.fileType ==='xls' || item.fileType ==='xlsx'" class="icon_excel"></span>
          <span v-else-if="item.fileType ==='doc' || item.fileType ==='docx'" class="icon_word"></span>
          <span v-else-if="item.fileType ==='ppt' || item.fileType ==='pptx'" class="icon_ppt"></span>
          <span v-else class="icon_file_default"></span>
          <span class="attachName">{{ item.attachName }}</span>
        </div>
        <div class="hint">
          提示：点击预览或下载附件
        </div>
      </div>
    </div>

    <div class="bottom-btn" v-if="listDetail.isTop==0">
      <van-button color="#096CEFFF" round @click.stop="onTop" block>置顶</van-button>
    </div>

  </div>
</template>

<script>
import { getSimpleProjectInfo, getNormalProjectInfo } from '@api/getJob'
import project from '@/components/projectInfo'
import { callByCoin, onceCallCoins } from '@api/integralMall'
import { dataSave } from '@api/coins'

export default {
  name: 'projectInfo',
  components: {
    project,
  },
  data () {
    return {
      listDetail: {},
      center: [],
      token: '',
      overlayShow: false,
      projectId: '',
      projectType: '',
      isMore: true,
      haMore: false
    }
  },
  created () {

    this.token = localStorage.getItem('token')

    this.projectId = this.$route.query.id
    this.projectType = this.$route.query.projectType

    if (this.projectType == 1) {
      this.getNormalProjectInfo()
    } else {
      this.getProjectInfo()
    }
  },
  mounted () {
    if (this.projectType == 2) {
      setTimeout(() => {
        this.adMap()
      }, 500)
    }

    // 支付回调
    this.$bridge.registerHandler('paySuccess', (data, responseCallback) => {
      this.payment()
    })
  },
  methods: {
    // 置顶
    onTop () {
      let dataJson = {
        dataId: this.projectId,
        dataType: '1'
      }
      // 暂时储存临时数据
      dataSave(dataJson).then(res => {
        if (res.data.code === 200) {
          let data
          if (this.listDetail.isTop == 1) {
            data = {
              url: `${process.env.VUE_APP_BASE_HOST}/top?type=4&uid=` + res.data.data + '&id=' + this.projectId,
              title: '招工信息置顶'
            }
          } else {
            data = {
              url: `${process.env.VUE_APP_BASE_HOST}/top?type=4&uid=` + res.data.data,
              title: '招工信息置顶'
            }
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
        }
      })
    },
    // 获取招标详情
    getNormalProjectInfo () {
      getNormalProjectInfo({
        id: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.listDetail = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取简易详情
    getProjectInfo () {
      getSimpleProjectInfo({
        id: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.listDetail = res.data.data
          this.center = [this.listDetail.lng, this.listDetail.lat]

          setTimeout(() => {
            var els = this.$refs.intro
            if (els.scrollHeight > 130) {
              this.haMore = true
              this.isMore = true
            } else {
              this.isMore = false
            }
          }, 100)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    attachsDetail (attachUrl) {
      this.$bridge.callHandler('newPage', { url: attachUrl }, response => {
        console.log('response:', response)
      })
    },
    adMap () {
      var map = new AMap.Map('container', {
        zoom: 14, // 缩放级别
        center: this.center, // 设置地图中心点
        resizeEnable: false // 地图初始化加载定位到当前城市
      })
      // 获取初始中心点并赋值
      var marker = new AMap.Marker({
        map: map,
        position: this.center
      })
      marker.setLabel({
        offset: new AMap.Pixel(20, 20) // 修改label相对于maker的位置
      })
      var currentCenter = map.getCenter()// 此方法是获取当前地图的中心点
      this.center = [currentCenter.lng, currentCenter.lat]// 将获取到的中心点的纬度经度赋值给data的center
      const _that = this
      map.on('click', function (e) {
        // 获取极光统计所需数据
        _that.$bridge.callHandler('getDeviceInfo', 'h5_map_click', response => {
          console.log('response:', response)
        })

        _that.$bridge.callHandler('openAmap', response => {
          console.log('response:', response)
        })
        marker.markOnAMAP({
          position: marker.getPosition()
        })
      })
    },
    // 调用拨号功能
    callPhone () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, '找活')
        }
      } else {
        if (this.token && this.token !== 'undefined') {
          onceCallCoins({
            dataType: 1,
            dataId: this.$route.query.id
          }).then(res => {
            if (res.data.code === 200) {
              if (res.data.data.firstFlag === true) {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert', response => {
                  console.log('response:', response)
                })

                this.$dialog.confirm({
                  title: '拨打电话',
                  message:
                    `拨打电话，需要支付${res.data.data.value}个邀工币。`,
                  confirmButtonColor: '#096CEFFF'
                })
                  .then(() => {
                    this.payment()
                  })
                  .catch(() => {
                    // on cancel
                  })
              } else {
                callByCoin({
                  dataType: 1,
                  dataId: this.$route.query.id
                }).then(res => {
                  if (res.data.code === 200) {
                    const phoneNumber = res.data.data.phone
                    const data = { phone: phoneNumber }
                    this.$bridge.callHandler('callPhone', data, response => {
                      console.log('response:', response)
                    })
                  }
                })
              }
            } else {
              this.$toastMsg(res.data.msg)
            }
          })
        } else {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
        }
      }
    },
    payment () {
      callByCoin({
        dataType: 1,
        dataId: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          // 判断邀功币不足
          if (res.data.data.enough == 0) {
            const data = {
              title: '邀工币充值',
              url: `${process.env.VUE_APP_BASE_HOST}/coinsPay?coinRemain=` + res.data.data.coinRemain + '&coinNeed=' + res.data.data.coinNeed
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            const phoneNumber = res.data.data.phone
            this.$dialog.confirm({
              title: '拨打电话',
              message:
                '支付完成，您可以拨打电话',
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert_confirm', response => {
                  console.log('response:', response)
                })

                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 添加好友
    addFriends () {
      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()// 获取UA信息
      if (userAgent.indexOf('yaogong') == -1) { // 判断ua中是否含有和app端约定好的标识yaogong
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(this.$route.fullPath, '找活')
        }
      } else {
        if (this.token && this.token !== 'undefined') {
          const data = { imId: this.listDetail.imId }
          this.$bridge.callHandler('addFriends', data, response => {
            console.log('response:', response)
          })
        } else {
          // 登录页面
          this.$bridge.callHandler('jumpLogin', { isExpired: 0 }, response => {
            console.log('response:', response)
          })
        }
      }
    },
    // 招工方详情
    hirePartyDetail () {
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/hirePartyDetail?id=${this.listDetail.pubCompanyId}&category=${this.listDetail.category}&projectId=${this.$route.query.id}`,
        title: '基本信息'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.getJobSimpleDetail {

  .tagBox {
    span {
      display: inline-block;
      @include add_size($font_size_13);
      color: #096CEF;
      min-height: 20px;
      padding: 0 5px;
      text-align: center;
      background: rgba(9, 108, 239, 0.07);
      margin-right: 8px;
      border-radius: 2px;
      border: 1px solid #8DBEFE;

      &:last-child {
        margin-right: 0;
      }
    }

    margin-bottom: 10px;
  }

  .headline {
    margin: 0 0 10px 12px;
    @include add_size($font_size_17);
    color: #333333;
    font-weight: bold;
    border-left: 3px solid #096CEF;
    padding-left: 4px;
    height: 15px;
    line-height: 14px;
  }

  .view-div {
    background-color: #EF09281A;
    color: #EF1818FF;
    border-radius: 50px;
    margin: 0 15px 10px 15px;
    padding: 8px 10px
  }

  .basic {
    background-color: #fff;
    padding: 12px;
    color: #333;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.02);
    margin-bottom: 12px;

    .title {
      @include add_size($font_size_18);
      font-weight: 600;
    }

    .textTitle {
      @include add_size($font_size_16);
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .hint {
      @include add_size($font_size_15);
      color: #999;
    }

    .mapbox {
      width: 100%;
      height: 190px;
      position: relative;

      #container {
        width: 100%;
        height: 100%;
      }
    }

    .icon_dizhiBox {
      @include add_size($font_size_18);

      .icon_dizhi {
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
      }

      span {
        vertical-align: middle;
      }
    }

    .personLogo {
      margin-right: 10px;

      img {
        border-radius: 5px;
        width: 48px;
        height: 48px;
      }
    }

    #container {
      width: 100%;
      height: 197px;
      margin-top: 8px;
    }

    .hireParty {
      display: flex;

      span {
        vertical-align: middle;
      }
    }

    .otherPubBox {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .leftBox {
        display: inherit;
        align-items: center;
      }

      .btn_phone {
        width: 69px;
        height: 21px;
      }
    }

    .phoneBox {
      display: flex;
      border-top: 1px solid #ccc;
      padding-top: 9px;
      margin: 16px -12px 0;

      div {
        flex: 1;

        &:first-child {
          border-right: 1px solid #ccc;
          margin: -9px 0;
        }
      }

      img {
        height: 21px;
        margin: 0 auto;
      }

      .btn_addFriend {
        width: 84px;
        margin-top: 9px;
      }

      .btn_phone {
        width: 69px;
        flex: 1;
      }
    }

    .retract {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
    }
  }

  .company {
    padding: 15px 0px 20px 12px;
  }

  .btn-div {
    width: 60%;
    margin: 0 auto;
    margin-top: 25px;
  }

  .other-file-type {
    text-align: center;
    line-height: 84px;
    color: white;
    @include add_size($font_size_14);
  }

  .attachName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rightContainer {
    width: 100%;
  }

  .WRAST {
    position: relative;
    height: 20px;
    line-height: 22px;
    vertical-align: middle;

    .star_one {
      width: 20px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .star_two {
      width: 40px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .star_three {
      width: 60px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .star_four {
      width: 80px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .star_five {
      width: 100px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .icon_more {
      float: right;
      width: 45px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .btn_phone {
      float: right;
      margin-right: 15px;
      width: 100px;
      height: 30px;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .btn_phoneDai {
    float: right;
    margin-right: 8px;
    width: 94px;
    height: 28px;
    display: inline-block;
    vertical-align: middle;
  }

  .icon_zhankai {
    width: 48px;
    height: 20px;
    float: right;
  }
}

.project-info-div {
  padding-bottom: 55px;
}

</style>
